import React from "react";
//#region types
import { WintSuperkollAPIModelTimeReporting as APIModel } from "wint-api-client/dist/types";
import { TimeReportStatusProps } from "models/propTypes/timeReportingPropTypes";
import { IconDefinitionConstants } from "utils/constants";
import { StyleEnums } from "models/enums";
//#endregion
//#region components
import { Icon } from "components/common";
import { Grid, Tooltip } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const TimeReportStatus: React.FC<TimeReportStatusProps> = (props) => {
  function getTimeReportStatusIcon(status?: APIModel.TimeReportStatus) {
    const toolTip =
      props.status !== undefined
        ? LocalizationHelperInstance.getFormattedMessage(`TimeReporting.TimeReportStatus_${props.status}`, "")
        : "";

    switch (status) {
      case APIModel.TimeReportStatus.Open:
        return {
          type: StyleEnums.DisplayType.Warning,
          icon: IconDefinitionConstants.WLockOpen,
          toolTip: toolTip,
        };
      case APIModel.TimeReportStatus.Locked:
        return {
          type: StyleEnums.DisplayType.Info,
          icon: IconDefinitionConstants.WLock,
          toolTip: toolTip,
        };
      case APIModel.TimeReportStatus.Approved:
        return {
          type: StyleEnums.DisplayType.Info,
          icon: IconDefinitionConstants.WCheck,
          toolTip:
            toolTip +
            (props.approvedBy && toolTip
              ? ` ${LocalizationHelperInstance.getFormattedMessage(`Common.By`)} ${props.approvedBy}`
              : ""),
        };
      case APIModel.TimeReportStatus.Attested:
        return {
          type: StyleEnums.DisplayType.Success,
          icon: IconDefinitionConstants.WCheck,
          toolTip: toolTip,
        };
      default:
        return {};
    }
  }

  const iconValue = getTimeReportStatusIcon(props.status);

  return iconValue.icon ? (
    <Tooltip
      disableInteractive
      placement="top"
      title={iconValue.toolTip}
      classes={{ tooltip: cssExports.tooltip, popper: cssExports.tooltipPopper }}
    >
      <Grid item>
        <Icon icon={iconValue.icon} displayType={iconValue.type} />
      </Grid>
    </Tooltip>
  ) : (
    <></>
  );
};

export default TimeReportStatus;
